import Vue from "vue";
import Router from "vue-router";
import Profile from "./views/Profile.vue";
import List from "./views/List.vue";
import Chat from "./views/Chat.vue";
import LeadDetail from "./views/LeadDetail.vue";
import Detail from "./views/Detail.vue";
import Excel from "./views/Excel.vue";
import Task from "./views/Task.vue";
import ReportUtm from "./views/ReportUtm.vue";
import ReportMonthly from "./views/ReportMonthly.vue";
import ReportAgent from "./views/ReportAgent.vue";
import Dashboard from "./views/Dashboard.vue";
import Edit from "./views/Edit.vue";
import Login from "./views/Login.vue";
import Logout from "./views/Logout.vue";
import CallPeriod from "./views/CallPeriod.vue";
import UserPermissions from "./views/UserPermissions.vue";
import AuthService from "./services/auth";
import Hooks from "./views/Hook.vue";
import Bids from "./views/Bid.vue";
import BidDetail from "./views/BidDetail.vue";
import Admin from "./views/Admin.vue";
import AdminDashboard from "./views/AdminDashboard.vue";
import QuizBuilder from "./views/QuizBuilder.vue";
import NotFound from "./views/NotFound.vue";
import Transactions from "./views/Transactions.vue";
import Reports from "./views/Reports.vue";
import ImportReport from "./views/ImportReport.vue";
import PieFirstFundReport from "./views/PieFirstFundReport.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/notfound",
      name: "NotFound",
      component: NotFound,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/tasks",
      name: "tasks",
      component: Task,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/call-periods",
      name: "call-periods",
      component: CallPeriod,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },  {
      path: "/piechart/firstFund",
      name: "PieFirstFundReport",
      component: PieFirstFundReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/transactions",
      name: "transactions",
      component: Transactions,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/list/:table",
      name: "list",
      component: List,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/chat",
      name: "chat",
      component: Chat,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/chat/ch/:channel",
      name: "chat-channel",
      component: Chat,
      meta: {
        requiresAuth: true,
        location: 1,
      },
    },
    {
      path: "/excel/:table",
      name: "excel",
      component: Excel,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/user/permissions/:id",
      name: "UserPermissions",
      component: UserPermissions,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/detail/:table/:id",
      name: "detail",
      component: Detail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/edit/:table/:id",
      name: "edit",
      component: Edit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin",
      name: "admin",
      component: AdminDashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin/:table",
      name: "adminDetail",
      component: Admin,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/hooks",
      name: "hooks",
      component: Hooks,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/bids",
      name: "bids",
      component: Bids,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/bids/:lead_id/:id",
      name: "bids_detail",
      component: BidDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/quizbuilder",
      name: "quizbuilder",
      component: QuizBuilder,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/leadDetail/:id",
      name: "leadDetail",
      component: LeadDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/utm",
      name: "report/utm",
      component: ReportUtm,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/agent",
      name: "report/agent",
      component: ReportAgent,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report/monthly",
      name: "report/monthly",
      component: ReportMonthly,
      meta: {
        requiresAuth: true,
      },
    },   {
      path: "/report/import",
      name: "report/import",
      component: ImportReport,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!localStorage.getItem("authToken")) {
      next({ path: "/login" });
    } else {
      AuthService.loginValidate()
        .then((resp) => {
          if (resp === false) {
            next({
              path: "/login",
              params: { nextUrl: to.fullPath },
            });
          } else {
            next();
          }
        })
        .catch((e) => {
          next({
            path: "/login",
            params: { nextUrl: to.fullPath },
          });
        });
    }
  } else {
    next();
  }
});

export default router;
